/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */

import {LogLevel} from "@azure/msal-browser";
// import { defaultAriaLiveMessages } from "react-select/dist/declarations/src/accessibility";

/**
 * Configuration object to be passed to MSAL instance on creation.
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md
 */
export const msalConfig = {
    auth: {
        // loginType: "popup",
        // test1002 clientID
        // clientId: "e301fecd-dc7f-4a23-9db2-254cecd08c80", // This is the ONLY mandatory field that you need to supply.
        //Pearson ClientID:
        clientId: process.env.REACT_APP_AD_CLIENT_ID,
        //test1002 authority(tenantId)
        // authority: "https://login.microsoftonline.com/f8f121b1-f777-416a-8b89-f37c54a78e41", // Defaults to "https://login.microsoftonline.com/common"
        //Pearson authority(tenantId)
        authority: `https://login.microsoftonline.com/${process.env.REACT_APP_AD_TENANT_ID}`,
        // test1002 redirect:
        // redirectUri: "http://localhost:3000", // Points to window.location.origin. You must register this URI on Azure Portal/App Registration.
        // Pearson Redirect
        // redirectUri: "http://localhost:3000/sign-in", // Points to window.location.origin. You must register this URI on Azure Portal/App Registration.
        
        // CURRENT WORKING REDIRECT:
        // redirectUri:  process.env.REACT_APP_SSO_REDIRECT_URI,
        redirectUri: process.env.REACT_APP_SSO_PAGE_REDIRECT_URI,
        
        postLogoutRedirectUri: "/", // Indicates the page to navigate after logout.
        navigateToLoginRequestUrl: true, // If "true", will navigate back to the original request location before processing the auth code response.
    },
    cache: {
        cacheLocation: "sessionStorage", // Configures cache location. "sessionStorage" is more secure, but "localStorage" gives you SSO between tabs.
        storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
    },
    system: {
        loggerOptions: {
            loggerCallback: (level, message, containsPii) => {
                if (containsPii) {
                    return;
                }
                switch (level) {
                    case LogLevel.Error:
                        // console.error(message);
                        return;
                    case LogLevel.Info:
                        // console.info(message);
                        return;
                    case LogLevel.Verbose:
                        // console.debug(message);
                        return;
                    case LogLevel.Warning:
                        // console.warn(message);
                        return;
                    default:
                }
            }
        }
    }
};

/**
 * Scopes you add here will be prompted for user consent during sign-in.
 * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
 * For more information about OIDC scopes, visit:
 * https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
 */
export const loginRequest = {
    scopes: ["User.Read", "Mail.Read", "profile"],
    redirectUri: process.env.REACT_APP_SSO_PAGE_REDIRECT_URI
};

/**
 * Add here the endpoints and scopes when obtaining an access token for protected web APIs. For more information, see:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/resources-and-scopes.md
 */
export const graphConfig = {
    graphMe: {
        type: "me",
        endpoint: "https://graph.microsoft.com/v1.0/me",
        scopes: ["User.Read"],
    },
    // graphMessages: {
    //     type: "messages",
    //     endpoint: "https://graph.microsoft.com/v1.0/me/messages",
    //     scopes: ["Mail.Read"],
    // },
    graphPeople: {
        type: "people",
        endpoint: "https://graph.microsoft.com/v1.0/me/people",
        scopes: ["People.Read"],
    },
    graphUsers: {
        type: "users",
        endpoint: "https://graph.microsoft.com/v1.0/users",
        scopes: ["User.Read", "profile"],
    },
    // armTenants: {
    //     endpoint: "https://management.azure.com/tenants?api-version=2020-01-01",
    //     scopes: ["https://management.azure.com/user_impersonation"],
    // },
    // NEW SCOPES
    allAccess: {
        scopes: [
            "Mail.Read",
            "Channel.Create",
            "Channel.Delete.All",
            "Channel.ReadBasic.All",
            "ChannelMessage.Delete",
            "ChannelMessage.Edit",
            "ChannelMessage.Read.All",
            "ChannelMessage.Send",
            "ChannelSettings.ReadWrite.All",
            "Chat.Create",
            "Chat.ReadBasic",
            "Chat.ReadWrite",
            "Directory.AccessAsUser.All",
            "Directory.ReadWrite.All",
            "Group.ReadWrite.All",
            "Team.Create",
            "Team.ReadBasic.All",
            "User.Read",
            "User.ReadWrite.All",
        ],
    }
}

// export const graphConfig = {
//     graphMeEndpoint: "https://graph.microsoft.com/v1.0/me",
//     graphMailEndpoint: "https://graph.microsoft.com/v1.0/me/messages",
//     graphUsersEndpoint: "https://graph.microsoft.com/v1.0/users",
//     // graphCreateGroup: `https://graph.microsoft.com/v1.0/users/${process.env.OWNER_ID}`,
//     graphCreateGroupEndpoint: `https://graph.microsoft.com/v1.0/groups`,
//     // graphCreateTeamEndpoint: `https://graph.microsoft.com/v1.0/groups/${group.id}/team`,
//     graphCreateTeamEndpoint: `https://graph.microsoft.com/v1.0/teams`,
// };

// export const graphUri = {
//     "create-group": "/groups",
//     "create-team": `/teams`,
//     // "create-channel": `/teams/${teamId}/channels`,
//     "create-channel": `/teams/5834e4c1-2897-4cc3-b274-91a091900b56/channels`,
//     // "create-message": `/teams/${teamId}/channels/${channelId}/messages`,
//     "create-message": `/teams/4a7c571b-f18e-4253-8aef-21bdc9c6c189/channels/19:beb630721f6743f0a7d2e650e48ee16e@thread.tacv2/messages`
// }
